import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { TreeSelectionModel } from './tree-selection.model';
import { FilterItemsService } from './filter-items.service';
import { StorageService } from "../core/services/index";
import { consts } from "./consts";
import { MediationFilters } from "../mediation/mediation.filters";

@Component({
    selector: 'publishers-selected-items',
    templateUrl: 'publishers-selected-items.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublishersSelectedItemsComponent implements OnInit {
    public items: Array<string> = new Array<string>();

    constructor(
        private filterItemsService: FilterItemsService,
        private storageService: StorageService) {
    }

    ngOnInit() {
        let publisherFromStorage = this.storageService.get(consts.PublisherIdsFilterStorageKey);
        let mediationFilter = <MediationFilters>this.storageService.get(consts.MediationFilterStorageKey);
        if (publisherFromStorage || mediationFilter) {
            if (publisherFromStorage) {
                let items = <Array<Number>>publisherFromStorage;
                let publishers = this.filterItemsService.getPublishers();
                let labels = publishers.filter(s => items.indexOf(s.value) > -1);
                labels.forEach(s => this.items.push(s.label));
            }

            if (mediationFilter) {
                let publishers = this.filterItemsService.getPublishers();
                let item = publishers.find(s => s.value === mediationFilter.publisherId);
                this.items.push(item.label);
            }
        }
        else
            this.items.push("All");
    }

    public onPublishersChanged(ids) {
        if (ids) {
            this.items.splice(0);
            let publishers = this.filterItemsService.getPublishers();
            if (ids.length == publishers.length) {
                this.items.push("All");
            }
            else {
                for (let id of ids) {
                    let publisher = publishers.find(s => s.value === id);
                    if (publisher)
                        this.items.push(publisher.label);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/publishers-selected-items.component.ts